import type { FaireProductEntity } from "../../entity_types/product";

export const atc_toast_11: FaireProductEntity = {
  token: "atc_toast_11",
  type: "product",
  name: "Retro Motel Keychain Set",
  brandName: "The Three Sisters",
  imageUrl: "",
  priceDollars: 5.5,
  msrpDollars: 11.0,
  description: "Migrated search/ATC mock product",
  tags: ["search", "prototype"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
